import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { useUnidades } from "../../hooks/test/useUnidades";
import useCeo from "../../hooks/useCEO";
import { formatDate } from "../../helpers/formatDate";
import { Spinner } from "../../components/Spinner";

export const BitacoraAdministracion = () => {
  const columns = [
    "USUARIO",
    "MOVIMIENTO ACTUAL",
    "MOVIMIENTO NUEVO",
    "FECHA/HORA MOVIMIENTO",
  ];

  const options = {
    selectableRows: "none",
    downloadOptions: {
      filename: "reporte-bitacora.csv",
      // separator: ";",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
      CharacterData: "utf-8",
      CharSet: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };

  useCeo({ title: "Bitacora", description: "BITÁCORA DE ADMINISTRACIÓN" });
  const { getBitacoraAdministracion } = useUnidades();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getBitacora();
  }, []);
  const getBitacora = async () => {
    setLoading(true);
    let resp = await getBitacoraAdministracion();
    if (resp.ok) {
      let array = [];
      resp.bitacoras.map((registro) => {
        const { registro_anterior, registro_nuevo, fecha_hora, usuario } =
          registro;

        let aux = [
          usuario ? usuario.name : "N/A",
          registro_anterior,
          registro_nuevo,
          formatDate(fecha_hora),
        ];
        array.push(aux);
        return "";
      });
      setData([...array]);
    }
    setLoading(false);
  };
  return (
    <>
      {loading && <Spinner />}
      <MUIDataTable
        title={"Bitacora de movimientos"}
        data={data}
        columns={columns}
        options={options}
        onDownload={(buildHead, buildBody, columns, data) => {
          return "\uFEFF" + buildHead(columns) + buildBody(data);
        }}
      />
    </>
  );
};
